exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".poiPopup-8977ea37{font-size:13px;line-height:15px;width:202px}.poiPopup-8977ea37 h4{font-size:14px;font-weight:500}.poiPopup-8977ea37 p{margin-bottom:5px;overflow-wrap:break-word}.Photogrid-865c0f0b{margin:5px -5px 0 0;font-size:0;line-height:0}.Photogrid-865c0f0b img{height:64px;width:64px;background:#E0E0E0;margin:5px 5px 0 0;display:inline-block;cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"poiPopup": "poiPopup-8977ea37",
	"Photogrid": "Photogrid-865c0f0b"
};